import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { LoadScript } from "@react-google-maps/api";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import FloatingSupportChat from "./components/FloatingSupportChat";
import Feedback from "./pages/Feedback";
import Home from "./pages/Home";
import Homenew from "./pages/Homenew";
import Homenewajp from "./pages/Homenewajp";
import Homenewajpv2 from "./pages/Homenewajpv2";
import HomeMinibusGrab from "./pages/HomeMinibusGrab";
import HomeCoachGrab from "./pages/HomeCoachGrab";
import Payment from "./pages/Payment";
import Paymentnew from "./pages/Paymentnew";
import PaymentSuccessnew from "./pages/PaymentSuccessnew";
import PaymentCancelnew from "./pages/PaymentCancelnew";
import PrivateBooking from "./pages/PrivateBooking";
import PrivateBookingSuccess from "./pages/PrivateBookingSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import BookingConfirmation from "./pages/BookingConfirmation";
import Driver from "./pages/Driver";
import DriverSuccess from "./pages/DriverSuccess";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Group from "./pages/Group";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import HomeMinibus from "./pages/HomeMinibus";
import HomeCoach from "./pages/HomeCoach";
import Faq from "./pages/Faq";
import Events from "./pages/Events";
import ScrollToTop from "./components/ScrollToTop";
import TerminalFinder from "./pages/TerminalFinder";
import AirlineContacts from "./pages/AirlineContacts";
import London from "./pages/London";
import HeathrowTaxi from "./pages/HeathrowTaxi";
import HeathrowInfo from "./pages/HeathrowInfo";
import Fleet from "./pages/Fleet";
import OurDrivers from "./pages/OurDrivers";
import HeathrowHotels from "./pages/HeathrowHotels";
import HeathrowAttractions from "./pages/HeathrowAttractions";
import SloughTaxi from "./pages/SloughTaxi";
import WindsorTaxi from "./pages/WindsorTaxi";
import MaidenheadTaxi from "./pages/MaidenheadTaxi";
import Slough from "./pages/Slough";
import HeathrowMinibusHire from "./pages/HeathrowMinibusHire";
import HeathrowCoachHire from "./pages/HeathrowCoachHire";
import HeathrowToWindsor from "./pages/HeathrowToWindsor";
import HeathrowToSlough from "./pages/HeathrowToSlough";
import SloughToHeathrow from "./pages/SloughToHeathrow";
import MaidenheadToHeathrow from "./pages/MaidenheadToHeathrow";
import WindsorToHeathrow from "./pages/WindsorToHeathrow";
import BurnhamTaxi from "./pages/BurnhamTaxi";
import BurnhamToHeathrow from "./pages/BurnhamToHeathrow";
import TaplowTaxi from "./pages/TaplowTaxi";
import TaplowToHeathrow from "./pages/TaplowToHeathrow";
import AscotTaxi from "./pages/AscotTaxi";
import AscotToHeathrow from "./pages/AscotToHeathrow";
import DorneyLakeTaxi from "./pages/DorneyLakeTaxi";
import HenleyTaxi from "./pages/HenleyTaxi";
import HenleyToHeathrow from "./pages/HenleyToHeathrow";
import HeathrowToAscotTaxi from "./pages/HeathrowToAscotTaxi";
import HeathrowToHenleyTaxi from "./pages/HeathrowToHenleyTaxi";
import HeathrowToMaidenhead from "./pages/HeathrowToMaidenhead";
import HeathrowToLondon from "./pages/HeathrowToLondon";
import SloughAirportPremiumRoute from "./pages/SloughAirportPremiumRoute";
import SloughToHeathrowGroupRoute from "./pages/SloughToHeathrowGroupRoute";
import SloughToHeathrowCoachRoute from "./pages/SloughToHeathrowCoachRoute";
import GroupRoutePage from "./pages/GroupRoutePage";
import { generatedGroupRouteRoutes } from "./data/generatedCityRouteConfigs";
import GeneratedCcgRoutePage from "./pages/GeneratedCcgRoutePage";
import { generatedCcgRouteRoutes } from "./data/generatedCcgRouteConfigs";
import GroupServicePage from "./pages/GroupServicePage";
import MinibusHire from "./pages/MinibusHire";
import CoachHire from "./pages/CoachHire";
import TravelNews from "./pages/TravelNews";
import NotFound from "./pages/NotFound";
import ParkingVsTaxi from "./pages/ParkingVsTaxi";
import ParkingVsTaxi7days from "./pages/ParkingVsTaxi7days";
import ParkingVsTaxiReading from "./pages/ParkingVsTaxiReading";
import ParkingVsTaxiOxford from "./pages/ParkingVsTaxiOxford";
import ParkingVsTaxiLondon from "./pages/ParkingVsTaxiLondon";
import ParkingVsTaxiT5 from "./pages/ParkingVsTaxiT5";
import TrainVsTaxiElizabeth from "./pages/TrainVsTaxiElizabeth";
import TrainVsTaxiHeathrowExpress from "./pages/TrainVsTaxiHeathrowExpress";
import TrainVsTaxiHeathrow from "./pages/TrainVsTaxiHeathrow";
import TrainVsTaxiGatwick from "./pages/TrainVsTaxiGatwick";
import TrainVsTaxiManchester from "./pages/TrainVsTaxiManchester";
import TrainVsTaxiLuton from "./pages/TrainVsTaxiLuton";
import TrainVsTaxiStansted from "./pages/TrainVsTaxiStansted";
import TrainVsTaxiEdinburgh from "./pages/TrainVsTaxiEdinburgh";
import TrainVsTaxiBirmingham from "./pages/TrainVsTaxiBirmingham";
import TrainVsTaxiBristol from "./pages/TrainVsTaxiBristol";
import TrainVsTaxiFamily from "./pages/TrainVsTaxiFamily";
import TrainVsTaxiGroup from "./pages/TrainVsTaxiGroup";
import TrainVsTaxiCheapest from "./pages/TrainVsTaxiCheapest";
import HowToGetToEastMidlandsAirport from "./pages/HowToGetToEastMidsAirport";
import HowToGetToEastMidlandsAirportV2 from "./pages/east-midlands-airport/HowToGetToEastMidsAirportv2";
import HowToGetToLHRv2 from "./pages/heathrow/HowToGetToLHRv2";
import BirminghamToLHR from "./pages/heathrow/BirminghamToLHR";
import LondonToLHR from "./pages/heathrow/LondonToLHR";
import ReturnFromLHR from "./pages/heathrow/ReturnFromLHR";
import ReturnFromEMA from "./pages/east-midlands-airport/ReturnFromEMA";
import LondonToEMA from "./pages/east-midlands-airport/LondonToEMA";
import BirminghamToEMA from "./pages/east-midlands-airport/BirminghamToEMA";
import WhenToLeaveForEMA from "./pages/east-midlands-airport/WhenToLeaveForEMA";
import HowToGetToHeathrow from "./pages/HowToGetToHeathrow";
import TrainVsTaxiEastMidlandsAirport from "./pages/TrainVsTaxiEastMid";
import TrainVsTaxi from "./pages/TrainVsTaxi";
import LeaveForHeathrowLite from "./pages/LeaveForHeathrowlite";
import LeaveForHeathrowPickup from "./pages/LeaveForHeathrowpickup";
import HeathrowFareCompareCheapest from "./pages/HeathrowFareCompareCheapest";
import FlightChecker from "./pages/FlightChecker";
import FlightCheckerT2 from "./pages/FlightCheckerT2";
import FlightCheckerT3 from "./pages/FlightCheckerT3";
import FlightCheckerT4 from "./pages/FlightCheckerT4";
import FlightCheckerT5 from "./pages/FlightCheckerT5";
import LeaveForHeathrow from "./pages/LeaveForHeathrow";
import ArrivalAssistant from "./pages/ArrivalAssistant";
import HeathrowFareCompare from "./pages/HeathrowFareCompare";
import HeathrowFareCompareLite from "./pages/HeathrowFareCompareLite";
import LegolandBudgetPlanner from "./pages/LegolandBudgetPlanner";
import LegolandHeathrow from "./pages/LegolandHeathrow";
import WindsorCastleBudgetPlanner from "./pages/WindsorCastleBudgetPlanner";
import ThorpeParkBudgetPlanner from "./pages/ThorpeParkBudgetPlanner";
import LegolandVsThorpePark from "./pages/LegolandVsThorpePark";
import HeathrowSurvey from "./pages/HeathrowSurvey";
import AJPSurvey from "./pages/AJPSurvey";
import QuoteResultsnew from "./pages/QuoteResultsnew";
import QuoteResultsmini from "./pages/QuoteResultsmini";
import QuoteResultscoach from "./pages/QuoteResultscoach";
import BookingV2 from "./pages/BookingV2";
import BookingV2Premium from "./pages/BookingV2Premium";
import HeathrowDropoffCalculator from "./pages/HeathrowDropoffCalculator";
import HeathrowfreeDropoffCalculator from "./pages/HeathrowfreeDropoffCalculator";
import HeathrowbluebadgeDropoffCalculator from "./pages/HeathrowbluebadgeDropoffCalculator";
import HeathrowT5DropoffCalculator from "./pages/HeathrowT5DropoffCalculator";
import HeathrowT2DropoffCalculator from "./pages/HeathrowT2DropoffCalculator";
import HeathrowT3DropoffCalculator from "./pages/HeathrowT3DropoffCalculator";
import HeathrowT4DropoffCalculator from "./pages/HeathrowT4DropoffCalculator";
import HeathrowDropoffvsShortstayCalculator from "./pages/HeathrowDropoffvsShortstayCalculator";
import HeathrowDropoff from "./pages/HeathrowDropoff";
import GatwickDropoffCalculator from "./pages/GatwickDropoffCalculator";
import GatwickDropoff from "./pages/GatwickDropoff";
import StanstedkDropoffCalculator from "./pages/StanstedkDropoffCalculator";
import StanstedDropoff from "./pages/StanstedDropoff";
import ManchesterDropoffCalculator from "./pages/ManchesterDropoffCalculator";
import EastMidlandsDropoff from "./pages/east-midlands-airport/EastMidlandsDropoff";
import ArrivalAssistantStudent from "./pages/ArrivalAssistantStudent";
import ArrivalAssistantStudentV3 from "./pages/ArrivalAssistantStudentV3";
import ArrivalAssistantVisitor from "./pages/ArrivalAssistantVisitor";
import ArrivalAssistantWorker from "./pages/ArrivalAssistantWorker";
import JourneyEvaluate from "./pages/JourneyEvaluate";
import EmaMonitorDashboardAdmin from "./pages/EmaMonitorDashboardAdmin";
import DevAdhocEmail from "./pages/DevAdhocEmail";
import AnalyticsV2 from "./pages/AnalyticsV2";
import HeathrowStatus from "./pages/HeathrowStatus";
import IntelligenceAlertingView from "./pages/IntelligenceAlertingView";
import AirportAlertAssurance from "./pages/AirportAlertAssurance";
import EnquiryThankYou from "./pages/EnquiryThankYou";
import StudentEnquiryThankYou from "./pages/StudentEnquiryThankYou";
import JourneyAlertThankYou from "./pages/JourneyAlertThankYou";
import AjpAirportPage from "./pages/AjpAirportPage";
import AjpCityAirportRoutePage from "./pages/AjpCityAirportRoutePage";
import * as ajpPageRegistry from "./data/ajpPageRegistry";
import AjpPaidAirportPlannerPage from "./pages/AjpPaidAirportPlannerPage";
import { ajpPaidPlannerPages } from "./data/ajpPaidPlannerPages";
import AjpRoutePlannerPage from "./pages/AjpRoutePlannerPage";
import { ajpRoutePlannerPages } from "./data/ajpRoutePlannerPages";

const { ajpAirportPages, ajpCityRoutePages } = ajpPageRegistry;

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const configuredSiteMode = process.env.REACT_APP_SITE_MODE || "";
const resolveSiteMode = () => {
  const host = typeof window !== "undefined" ? window.location.hostname.toLowerCase() : "";
  if (host.includes("minibusgrab")) return "minibusgrab";
  if (host.includes("cheapcoachgrab")) return "cheapcoachgrab";
  if (host.includes("airportjourneyplanner")) return "planner";
  return configuredSiteMode || "ccg";
};
const SITE_MODE = resolveSiteMode();
const ENABLE_SUPPORT_CHAT = process.env.REACT_APP_ENABLE_SUPPORT_CHAT === "true";

const ManageBooking = () => (
  <div style={{ padding: "50px" }}>
    <h2>Manage Your Booking</h2>
  </div>
);

const App = () => {
  const isPlanner = SITE_MODE === "planner";
  const isMinibusGrab = SITE_MODE === "minibusgrab";
  const isCoachGrab = SITE_MODE === "cheapcoachgrab";
  const minibusHirePage = isMinibusGrab ? <HomeMinibusGrab /> : <MinibusHire />;
  const coachHirePage = isCoachGrab ? <HomeCoachGrab /> : <CoachHire />;
  const pathname = typeof window !== "undefined" ? window.location.pathname : "";
  const isOperationsPage =
    pathname === "/heathrow/status" ||
    pathname === "/heathrow-status" ||
    pathname === "/intelligence-alerting" ||
    pathname === "/alerts/intelligence" ||
    pathname === "/airport-alert-assurance";
  // Every V3 comparison page can open the enquiry flow, so keep its chat
  // listener mounted on the home, preview, airport and city-route pages.
  const isGeneratedAjpPage = [...ajpAirportPages, ...ajpCityRoutePages, ...ajpPaidPlannerPages, ...ajpRoutePlannerPages].some((page) => page.path === pathname);
  const isAjpV3ConversionPage = isPlanner && (pathname === "/" || pathname === "/ajp-v2-preview" || isGeneratedAjpPage);
  const shouldShowSupportChat = !isOperationsPage && (ENABLE_SUPPORT_CHAT || isAjpV3ConversionPage);

  return (
    <LoadScript
      googleMapsApiKey={GOOGLE_MAPS_API_KEY}
      libraries={["places"]}
      preventGoogleFontsLoading={true}
    >
      <Router>
        <ScrollToTop />
        <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
          {!isOperationsPage ? <Navbar siteMode={SITE_MODE} isPlanner={isPlanner} /> : null}

          <div style={{ flex: 1, minHeight: "80vh", background: "#f9fafb" }}>
            <Routes>
              <Route path="/" element={isPlanner ? <Homenewajpv2 /> : isMinibusGrab ? <HomeMinibusGrab /> : isCoachGrab ? <HomeCoachGrab /> : <Homenew />} />
              {isPlanner ? <Route path="/ajp-v2-preview" element={<Navigate to="/" replace />} /> : null}
              {isPlanner ? <Route path="/ajp-v1-preview" element={<Homenewajp />} /> : null}
              <Route path="/old" element={<Home />} />
              <Route path="/results/:quoteId/:token" element={<QuoteResultsnew />} />
              <Route path="/minibus-results/:quoteId/:token" element={<QuoteResultsmini />} />
              <Route path="/coach-results/:quoteId/:token" element={<QuoteResultscoach />} />
              <Route path="/thank-you" element={<EnquiryThankYou />} />
              {isPlanner ? <Route path="/journey-alert-thank-you" element={<JourneyAlertThankYou />} /> : null}
              <Route path="/international-students/enquiry-received" element={<StudentEnquiryThankYou />} />
              <Route path="/book/:quoteId/:token/:vehicleCode" element={<BookingV2 />} />
              <Route path="/minibus-book/:quoteId/:token/:vehicleCode" element={<BookingV2Premium />} />
              <Route path="/coach-book/:quoteId/:token/:vehicleCode" element={<BookingV2Premium />} />
              <Route path="/payment-new" element={<Paymentnew />} />
              <Route path="/payment-success-new" element={<PaymentSuccessnew />} />
              <Route path="/payment-cancel-new" element={<PaymentCancelnew />} />
              <Route path="/private-book/:token" element={<PrivateBooking />} />
              <Route path="/private-booking-success" element={<PrivateBookingSuccess />} />

              <Route
                path="/payment"
                element={
                  <Elements stripe={stripePromise}>
                    <Payment />
                  </Elements>
                }
              />

              <Route path="/group" element={<Group />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/services" element={<Services />} />
              <Route path="/manage-booking" element={<ManageBooking />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/booking-confirmation/:refCode" element={<BookingConfirmation />} />
              <Route path="/driver" element={<Driver />} />
              <Route path="/driver-success" element={<DriverSuccess />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancel" element={<PaymentCancel />} />
              <Route path="/minibus" element={minibusHirePage} />
              <Route path="/coach" element={coachHirePage} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/events" element={<Events />} />
              <Route path="/london" element={<London />} />
              <Route path="/terminalFinder" element={<TerminalFinder />} />
              <Route path="/airlineContacts" element={<AirlineContacts />} />
              <Route path="/heathrow-taxi" element={<HeathrowTaxi />} />
              <Route path="/heathrow" element={isPlanner ? <HowToGetToLHRv2 /> : <HeathrowInfo />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/our-drivers" element={<OurDrivers />} />
              <Route path="/heathrow-hotels" element={<HeathrowHotels />} />
              <Route path="/heathrow-attractions" element={<HeathrowAttractions />} />
              <Route path="/slough-taxi" element={<SloughTaxi />} />
              <Route path="/windsor-taxi" element={<WindsorTaxi />} />
              <Route path="/maidenhead-taxi" element={<MaidenheadTaxi />} />
              <Route path="/burnham-taxi" element={<BurnhamTaxi />} />
              <Route path="/taplow-taxi" element={<TaplowTaxi />} />
              <Route path="/ascot-taxi" element={<AscotTaxi />} />
              <Route path="/dorney-lake-taxi" element={<DorneyLakeTaxi />} />
              <Route path="/dorney-lake-events-taxi" element={<DorneyLakeTaxi />} />
              <Route path="/heathrow-to-dorney-lake" element={<DorneyLakeTaxi />} />
              <Route path="/henley-taxi" element={<HenleyTaxi />} />
              <Route path="/slough" element={<Slough />} />
              <Route path="/heathrow-minibus-hire" element={<HeathrowMinibusHire />} />
              <Route path="/heathrow-coach-hire" element={<HeathrowCoachHire />} />
              <Route path="/heathrow-minibus" element={<GroupServicePage serviceKey="heathrow" variant="minibus" />} />
              <Route path="/heathrow-coach" element={<GroupServicePage serviceKey="heathrow" variant="coach" />} />
              <Route path="/gatwick-minibus-hire" element={<GroupServicePage serviceKey="gatwick" variant="minibus" />} />
              <Route path="/luton-minibus-hire" element={<GroupServicePage serviceKey="luton" variant="minibus" />} />
              <Route path="/stansted-minibus-hire" element={<GroupServicePage serviceKey="stansted" variant="minibus" />} />
              <Route path="/manchester-airport-minibus-hire" element={<GroupServicePage serviceKey="manchester" variant="minibus" />} />
              <Route path="/legoland-minibus-hire" element={<GroupServicePage serviceKey="legoland" variant="minibus" />} />
              <Route path="/heathrow-to-legoland-minibus" element={<GroupServicePage serviceKey="heathrow-legoland" variant="minibus" />} />
              <Route path="/london-to-legoland-minibus" element={<GroupServicePage serviceKey="london-legoland" variant="minibus" />} />
              <Route path="/heathrow-to-windsor-castle-minibus" element={<GroupServicePage serviceKey="heathrow-windsor-castle" variant="minibus" />} />
              <Route path="/thorpe-park-minibus-hire" element={<GroupServicePage serviceKey="thorpe-park" variant="minibus" />} />
              <Route path="/heathrow-to-windsor" element={<HeathrowToWindsor />} />
              <Route path="/heathrow-to-slough" element={<HeathrowToSlough />} />
              <Route path="/heathrow-to-maidenhead" element={<HeathrowToMaidenhead />} />
              <Route path="/heathrow-to-london" element={<HeathrowToLondon />} />
              <Route path="/heathrow-to-ascot-taxi" element={<HeathrowToAscotTaxi />} />
              <Route path="/heathrow-to-henley-taxi" element={<HeathrowToHenleyTaxi />} />
              <Route path="/slough-to-heathrow" element={<SloughToHeathrow />} />
              <Route path="/maidenhead-to-heathrow" element={<MaidenheadToHeathrow />} />
              <Route path="/windsor-to-heathrow" element={<WindsorToHeathrow />} />
              <Route path="/burnham-to-heathrow" element={<BurnhamToHeathrow />} />
              <Route path="/taplow-to-heathrow" element={<TaplowToHeathrow />} />
              <Route path="/ascot-to-heathrow" element={<AscotToHeathrow />} />
              <Route path="/henley-to-heathrow" element={<HenleyToHeathrow />} />
              {generatedCcgRouteRoutes.map(({ path, routeKey }) => (
                <Route key={`ccg-${path}`} path={path} element={<GeneratedCcgRoutePage routeKey={routeKey} />} />
              ))}
              <Route path="/slough-to-heathrow-minibus" element={<SloughToHeathrowGroupRoute variant="minibus" />} />
              <Route path="/slough-to-heathrow-minibus-hire" element={<SloughToHeathrowGroupRoute variant="minibus" />} />
              <Route path="/slough-to-heathrow-coach" element={<SloughToHeathrowCoachRoute />} />
              <Route path="/slough-to-heathrow-coach-hire" element={<SloughToHeathrowCoachRoute />} />
              <Route path="/heathrow-to-london-minibus" element={<GroupRoutePage routeKey="heathrow-to-london" variant="minibus" />} />
              <Route path="/heathrow-to-london-minibus-hire" element={<GroupRoutePage routeKey="heathrow-to-london" variant="minibus" />} />
              <Route path="/heathrow-to-london-coach" element={<GroupRoutePage routeKey="heathrow-to-london" variant="coach" />} />
              <Route path="/heathrow-to-london-coach-hire" element={<GroupRoutePage routeKey="heathrow-to-london" variant="coach" />} />
              <Route path="/maidenhead-to-heathrow-minibus" element={<GroupRoutePage routeKey="maidenhead-to-heathrow" variant="minibus" />} />
              <Route path="/maidenhead-to-heathrow-minibus-hire" element={<GroupRoutePage routeKey="maidenhead-to-heathrow" variant="minibus" />} />
              <Route path="/maidenhead-to-heathrow-coach" element={<GroupRoutePage routeKey="maidenhead-to-heathrow" variant="coach" />} />
              <Route path="/maidenhead-to-heathrow-coach-hire" element={<GroupRoutePage routeKey="maidenhead-to-heathrow" variant="coach" />} />
              <Route path="/windsor-to-heathrow-minibus" element={<GroupRoutePage routeKey="windsor-to-heathrow" variant="minibus" />} />
              <Route path="/windsor-to-heathrow-minibus-hire" element={<GroupRoutePage routeKey="windsor-to-heathrow" variant="minibus" />} />
              <Route path="/windsor-to-heathrow-coach" element={<GroupRoutePage routeKey="windsor-to-heathrow" variant="coach" />} />
              <Route path="/windsor-to-heathrow-coach-hire" element={<GroupRoutePage routeKey="windsor-to-heathrow" variant="coach" />} />
              <Route path="/ascot-to-heathrow-minibus" element={<GroupRoutePage routeKey="ascot-to-heathrow" variant="minibus" />} />
              <Route path="/ascot-to-heathrow-minibus-hire" element={<GroupRoutePage routeKey="ascot-to-heathrow" variant="minibus" />} />
              <Route path="/ascot-to-heathrow-coach" element={<GroupRoutePage routeKey="ascot-to-heathrow" variant="coach" />} />
              <Route path="/ascot-to-heathrow-coach-hire" element={<GroupRoutePage routeKey="ascot-to-heathrow" variant="coach" />} />
              <Route path="/henley-to-heathrow-minibus" element={<GroupRoutePage routeKey="henley-to-heathrow" variant="minibus" />} />
              <Route path="/henley-to-heathrow-minibus-hire" element={<GroupRoutePage routeKey="henley-to-heathrow" variant="minibus" />} />
              <Route path="/henley-to-heathrow-coach" element={<GroupRoutePage routeKey="henley-to-heathrow" variant="coach" />} />
              <Route path="/henley-to-heathrow-coach-hire" element={<GroupRoutePage routeKey="henley-to-heathrow" variant="coach" />} />
              {generatedGroupRouteRoutes.map(({ path, routeKey, variant }) => (
                <Route key={path} path={path} element={<GroupRoutePage routeKey={routeKey} variant={variant} />} />
              ))}
              <Route path="/slough-to-gatwick" element={<SloughAirportPremiumRoute airport="gatwick" />} />
              <Route path="/slough-to-luton" element={<SloughAirportPremiumRoute airport="luton" />} />
              <Route path="/slough-to-stansted" element={<SloughAirportPremiumRoute airport="stansted" />} />
              <Route path="/minibus-hire" element={minibusHirePage} />
              <Route path="/coach-hire" element={coachHirePage} />
              <Route path="/feedback" element={<Feedback />} />
              <Route path="/travelnews" element={<TravelNews />} />
              <Route path="/legoland-budget-planner" element={<LegolandBudgetPlanner />} />
              <Route path="/heathrow-to-legoland" element={<LegolandHeathrow />} />
              <Route path="/windsor-castle-budget-planner" element={<WindsorCastleBudgetPlanner />} />
              <Route path="/thorpepark-budget-planner" element={<ThorpeParkBudgetPlanner />} />
              <Route path="/legoland-vs-thorpe-park" element={<LegolandVsThorpePark />} />
              <Route path="/heathrow-parking-vs-taxi" element={<ParkingVsTaxi />} />
              <Route path="/7-day-heathrow-parking-vs-taxi" element={<ParkingVsTaxi7days />} />
              <Route path="/reading-heathrow-parking-vs-taxi" element={<ParkingVsTaxiReading />} />
              <Route path="/oxford-heathrow-parking-vs-taxi" element={<ParkingVsTaxiOxford />} />
              <Route path="/central-london-heathrow-parking-vs-taxi" element={<ParkingVsTaxiLondon />} />
              <Route path="/heathrow-terminal-5-parking-vs-taxi" element={<ParkingVsTaxiT5 />} />
              <Route path="/train-vs-taxi-elizabeth-line" element={<TrainVsTaxiElizabeth />} />
              <Route path="/heathrow-express-vs-taxi" element={<TrainVsTaxiHeathrowExpress />} />
              <Route path="/train-vs-taxi-heathrow" element={<TrainVsTaxiHeathrow />} />
              <Route path="/train-vs-taxi-gatwick" element={<TrainVsTaxiGatwick />} />
              <Route path="/train-vs-taxi-manchester-airport" element={<TrainVsTaxiManchester />} />
              <Route path="/train-vs-taxi-edinburgh-airport" element={<TrainVsTaxiEdinburgh />} />
              <Route path="/train-vs-taxi-birmingham-airport" element={<TrainVsTaxiBirmingham />} />
              <Route path="/train-vs-taxi-bristol-airport" element={<TrainVsTaxiBristol />} />
              <Route path="/how-to-get-to-east-midlands-airport" element={<HowToGetToEastMidlandsAirport />} />
              {isPlanner ? <Route path="/east-midlands-airport" element={<HowToGetToEastMidlandsAirportV2 />} /> : null}
              <Route path="/east-midlands-airport/live-journey-planner" element={<HowToGetToEastMidlandsAirportV2 />} />
              <Route path="/east-midlands-airport/london-to-east-midlands-airport" element={<LondonToEMA />} />
              <Route path="/east-midlands-airport/birmingham-to-east-midlands-airport" element={<BirminghamToEMA />} />
              <Route path="/east-midlands-airport/return-journey-monitoring" element={<ReturnFromEMA />} />
              <Route path="/east-midlands-airport/when-to-leave-for-east-midlands-airport" element={<WhenToLeaveForEMA />} />
              <Route path="/how-to-get-to-east-midlands-airport-v2" element={<HowToGetToEastMidlandsAirportV2 />} />
              <Route path="/heathrow/live-journey-planner" element={<HowToGetToLHRv2 />} />
              <Route path="/heathrow/status" element={<HeathrowStatus />} />
              <Route path="/heathrow-status" element={<HeathrowStatus />} />
              <Route path="/heathrow/birmingham-to-heathrow" element={<BirminghamToLHR />} />
              <Route path="/heathrow/london-to-heathrow" element={<LondonToLHR />} />
              <Route path="/heathrow/when-to-leave-for-heathrow" element={<LeaveForHeathrow />} />
              <Route path="/heathrow/return-journey-monitoring" element={<ReturnFromLHR />} />
              <Route path="/journey/:token/evaluate" element={<JourneyEvaluate />} />
              <Route path="/how-to-get-to-heathrow" element={<HowToGetToHeathrow />} />
              <Route path="/how-to-get-to-heathrow-airport" element={<HowToGetToHeathrow />} />
              <Route path="/train-vs-taxi-east-midlands-airport" element={<TrainVsTaxiEastMidlandsAirport />} />
              <Route path="/train-vs-taxi-for-families" element={<TrainVsTaxiFamily />} />
              <Route path="/train-vs-taxi-luton-airport" element={<TrainVsTaxiLuton />} />
              <Route path="/train-vs-taxi-stansted" element={<TrainVsTaxiStansted />} />
              <Route path="/train-vs-taxi-for-groups" element={<TrainVsTaxiGroup />} />
              <Route path="/cheapest-way-to-heathrow" element={<TrainVsTaxiCheapest />} />
              <Route path="/heathrow/train-vs-taxi" element={<TrainVsTaxiHeathrow />} />
              <Route path="/how-early-to-arrive-heathrow" element={<LeaveForHeathrowLite />} />
              <Route path="/heathrow-arrival-pickup-time" element={<LeaveForHeathrowPickup />} />
              <Route path="/cheapest-taxi-to-heathrow" element={<HeathrowFareCompareCheapest />} />
              <Route path="/train-vs-taxi" element={<TrainVsTaxi />} />
              <Route path="/flight-checker" element={<FlightChecker />} />
              <Route path="/terminal-2-flight-checker" element={<FlightCheckerT2 />} />
              <Route path="/terminal-3-flight-checker" element={<FlightCheckerT3 />} />
              <Route path="/terminal-4-flight-checker" element={<FlightCheckerT4 />} />
              <Route path="/terminal-5-flight-checker" element={<FlightCheckerT5 />} />
              <Route path="/leave-for-heathrow" element={<LeaveForHeathrow />} />
              <Route path="/arrival-assistant" element={<ArrivalAssistant />} />
              <Route path="/heathrow-fare-compare" element={<HeathrowFareCompare />} />
              <Route path="/heathrow-fare-compare-lite" element={<HeathrowFareCompareLite />} />
              <Route path="/heathrow-survey" element={<HeathrowSurvey />} />
              {isPlanner ? <Route path="/survey" element={<AJPSurvey />} /> : null}
              {isPlanner ? <Route path="/ajp-survey" element={<AJPSurvey />} /> : null}
              <Route path="/heathrow-dropoff-calculator" element={<HeathrowDropoffCalculator />} />
              <Route path="/heathrow-dropoff-free-2026" element={<HeathrowfreeDropoffCalculator />} />
              <Route path="/heathrow-blue-badge-dropoff" element={<HeathrowbluebadgeDropoffCalculator />} />
              <Route path="/heathrow-terminal-5-dropoff" element={<HeathrowT5DropoffCalculator />} />
              <Route path="/heathrow-terminal-2-dropoff" element={<HeathrowT2DropoffCalculator />} />
              <Route path="/heathrow-terminal-3-dropoff" element={<HeathrowT3DropoffCalculator />} />
              <Route path="/heathrow-terminal-4-dropoff" element={<HeathrowT4DropoffCalculator />} />
              <Route path="/heathrow-dropoff-vs-short-stay" element={<HeathrowDropoffvsShortstayCalculator />} />
              <Route path="/heathrow-dropoff" element={<HeathrowDropoff />} />
              <Route path="/gatwick-dropoff" element={<GatwickDropoff />} />
              <Route path="/gatwick-dropoff-calculator" element={<GatwickDropoffCalculator />} />
              <Route path="/stansted-dropoff" element={<StanstedDropoff />} />
              <Route path="/stansted-dropoff-calculator" element={<StanstedkDropoffCalculator />} />
              <Route path="/manchester-airport/drop-off-calculator" element={<ManchesterDropoffCalculator />} />
              <Route path="/east-midlands-airport/drop-off-calculator" element={<EastMidlandsDropoff />} />
              <Route path="/arrival-assistant-student" element={<ArrivalAssistantStudent />} />
              <Route path="/international-students/uk-arrival-guide" element={<ArrivalAssistantStudentV3 />} />
              <Route path="/international-students/airports/heathrow" element={<ArrivalAssistantStudentV3 landing="heathrow" />} />
              <Route path="/international-students/airports/gatwick" element={<ArrivalAssistantStudentV3 landing="gatwick" />} />
              <Route path="/international-students/airports/stansted" element={<ArrivalAssistantStudentV3 landing="stansted" />} />
              <Route path="/international-students/airports/manchester" element={<ArrivalAssistantStudentV3 landing="manchester_airport" />} />
              <Route path="/international-students/universities/brunel" element={<ArrivalAssistantStudentV3 landing="brunel" />} />
              <Route path="/international-students/universities/manchester" element={<ArrivalAssistantStudentV3 landing="manchester_university" />} />
              <Route path="/arrival-assistant-visitor" element={<ArrivalAssistantVisitor />} />
              <Route path="/arrival-assistant-worker" element={<ArrivalAssistantWorker />} />
              <Route path="/monitor/ema-admin" element={<EmaMonitorDashboardAdmin />} />
              <Route path="/analytics-v2" element={<AnalyticsV2 />} />
              <Route path="/intelligence-alerting" element={<IntelligenceAlertingView />} />
              <Route path="/alerts/intelligence" element={<IntelligenceAlertingView />} />
              <Route path="/airport-alert-assurance" element={<AirportAlertAssurance />} />
              {isPlanner
                ? ajpPaidPlannerPages.map((page) => (
                    <Route key={page.key} path={page.path} element={<AjpPaidAirportPlannerPage pageKey={page.key} />} />
                  ))
                : null}
              {isPlanner
                ? ajpRoutePlannerPages.map((page) => (
                    <Route key={page.key} path={page.path} element={<AjpRoutePlannerPage pageKey={page.key} />} />
                  ))
                : null}
              {isPlanner
                ? ajpAirportPages.map((page) => (
                    <Route key={`ajp-airport-${page.key}`} path={page.path} element={<AjpAirportPage pageKey={page.key} />} />
                  ))
                : null}
              {isPlanner
                ? ajpCityRoutePages.map((page) => (
                    <Route key={`ajp-route-${page.key}`} path={page.path} element={<AjpCityAirportRoutePage pageKey={page.key} />} />
                  ))
                : null}
              {process.env.NODE_ENV !== "production" ? (
                <Route path="/dev/adhoc-email" element={<DevAdhocEmail />} />
              ) : null}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>

          {shouldShowSupportChat ? <FloatingSupportChat brand={isPlanner ? "planner" : undefined} /> : null}
          {!isOperationsPage ? <Footer siteMode={SITE_MODE} isPlanner={isPlanner} /> : null}
        </div>
      </Router>
    </LoadScript>
  );
};

export default App;
